import { WebCrud } from '../../../containers/crud/webCrud';
import { Crud } from '../../../containers/crud/crud';
import { CrudForm } from '../../../containers/crud/crudForm';
import { UpdateEntity } from '../../../containers/updateEntity';
import { Switch } from 'antd/lib';

export default function Categories() {
  return (
    <WebCrud
      api="categories"
      FormComponent={(props) => (
        <CrudForm
          {...props}
          skipTranslate={true}
          elements={[
            {
              type: 'text',
              name: 'name',
              label: 'Name',
              required: true,
            },
            {
              type: 'file',
              name: 'image',
              label: 'Image',
              fileCode: 'configurationFile',
              uploadProps: {
                accept: 'image/*',
              },
            },
            {
              type: 'switch',
              name: 'active',
              label: 'Active',
            },
          ]}
        />
      )}
    >
      <Crud.Header title="Categories">
        <Crud.Header.Actions.Common>
          <Crud.Header.Actions.Add />
        </Crud.Header.Actions.Common>
      </Crud.Header>
      <Crud.Table
        actions={[
          () => <Crud.Table.RowActions.Edit />,
          Crud.Table.RowActions.Delete,
        ]}
        columns={[
          {
            title: 'Name',
            dataIndex: 'name',
          },
          {
            title: 'Slug',
            dataIndex: 'slug',
          },
          {
            title: 'Active',
            dataIndex: 'active',
            render: (_, record) => {
              return (
                <UpdateEntity
                  keyPropName="key"
                  getChildren={({ loading, updateEntity }) => {
                    return (
                      <Switch
                        loading={loading}
                        checked={record.active}
                        onChange={async (checked) => {
                          await updateEntity({ active: checked });
                        }}
                      />
                    );
                  }}
                />
              );
            },
          },
        ]}
      >
        <Crud.Table.TableActions.Common />
        <Crud.Table.Header>
          <Crud.Search
            fields={[
              {
                type: 'text',
                name: 'name',
                inputProps: {
                  placeholder: 'Category',
                },
              },
            ]}
          />
          <Crud.Table.BulkRowActions.Common />
        </Crud.Table.Header>
      </Crud.Table>
    </WebCrud>
  );
}
